module.exports = __webpack_public_path__ + "img/5_hills.4ee40fd6.jpg";